"use client";

import Image from "next/image"; 
import { Typography } from "@material-tailwind/react"; 
import { MotionDiv, MotionSection, MotionForm, Variants } from "@/utils/clientMotion";

const BENEFITS = [
  {
    title: "Easy to Use",
    description: "ใช้งานง่าย",
    img: "/image/benefits1.png",
  },
  {
    title: "Rewarding System",
    description: "มีระบบสะสมแต้ม, แลกของรางวัล",
    img: "/image/benefits2.png",
  },
  {
    title: "System Management",
    description: "มีระบบจัดการสำหรับผู้ดูแลระบบ",
    img: "/image/benefits3.png",
  },
  {
    title: "Notification Alarm",
    description: 'มีระบบแจ้งเตือนผ่าน <span class="!text-[#4CAF50]">LINE OA</span>',
    img: "/image/benefits4.png",
  },
];

// container variants: สั่งให้ลูกเด้งทีละตัว
const containerVariants: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.2, // เว้น 0.2s ระหว่างลูกแต่ละอัน
    },
  },
};

// item variants: เด้งเข้ามาจากขวา + หัวข้อเลื่อนลงมาจากบน
const itemVariants: Variants = {
  hidden: { x: 100, opacity: 0 },
  show:  { x:   0, opacity: 1, transition: { type: "spring", stiffness: 100 } },
};
const headerVariants: Variants = {
  hidden: { y: -50, opacity: 0 },
  show:   { y:   0, opacity: 1, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function ReBottBenefits() {
  return (
    <section className="!pt-20 pb-20 lg:pt-0 lg:!pb-0 bg-[#eff6ff]">
    <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 px-4">
      <MotionDiv
              className="hidden md:block relative w-full aspect-[480/880]"
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              >
        <Image
          src="/image/ReBott_RVM.webp"
          alt="Rebott ตู้คืนขวดพลาสติกอัจฉริยะ"
          fill
          className="object-contain"
        />
      </MotionDiv>
      
      <MotionDiv
              className="flex flex-col justify-center space-y-6"
              initial="hidden"
              whileInView="show"  
              viewport={{ once: false, amount: 0.3 }}
              variants={containerVariants}
              >
        <MotionDiv variants={headerVariants} className="text-center md:text-left">
          <Typography {...({} as any)} variant="h3" className="font-bold text-gray-800">
            ทำไมต้อง Rebott ?
          </Typography>
          <Typography {...({} as any)} variant="lead" className="text-[#2998E2]">
            Why choose Rebott?
          </Typography>
        </MotionDiv>

        <div className="space-y-4">
            {BENEFITS.map((b, i) => (
              <MotionDiv
                key={i}
                variants={itemVariants}

                // เพิ่ม animate เวลาโฮเวอร์ ให้ยกขึ้นนิดๆ
                whileHover={{ y: -5, boxShadow: "0 4px 14px rgba(0,0,0,0.1)" }}
                // transition={{ type: "spring", stiffness: 300 }}
                // whileHover={{ scale: 1.03 }}          // เติมถ้าต้องการเด้งนิดหน่อย
                transition={{ type: "spring", stiffness: 200, damping: 15 }}
                // เพิ่มตอนกดให้ดีดเด้ง
                whileTap={{ scale: 0.95, backgroundColor: "#eff6ff" }}

                className="group bg-white rounded-[25px] px-2 py-2 lg:py-2 lg:px-4
                flex items-center gap-4 shadow-md
                cursor-pointer
                hover:scale-105 
                "
              >
                <div className="flex-shrink-0">
                <div className="relative w-24 h-24 ml-1">
                  <Image
                    src={b.img}
                    alt={b.title}
                    fill
                    className="object-contain"
                    priority
                  />
                </div>
                </div>
                <div>
                  <Typography {...({} as any)} 
                    variant="h3"
                    className="text-[1.3rem] lg:text-[27px] font-semibold text-gray-800 mb-1 
                    tracking-wide 
                    group-hover:text-[#2998E2]
                    "
                  >
                    {b.title}
                  </Typography>
                  <Typography {...({} as any)} 
                    variant="lead"
                    className="text-[1rem] lg:text-xl text-[#2998E2] tracking-wide"
                    dangerouslySetInnerHTML={{ __html: b.description }}
                  />
                    {/* {b.description} */}
                  {/* </Typography> */}
                </div>
              </MotionDiv>
            ))}
        </div>
      </MotionDiv>
    </div>
  </section>
  );
}
